import React from "react";
import { motion } from "framer-motion";
import { ClipboardList, Eye, Rocket, type LucideIcon } from "lucide-react";

type ProcessStep = {
  title: string;
  text: string;
  icon: LucideIcon;
  tone: "orange" | "blue" | "green";
};

const steps: ProcessStep[] = [
  {
    title: "Make Plans How to Proceed",
    text: "To make sure that you don't lose direction or face confusion in the middle of the redesigning process, it is important to plan the process. As a top website redesign company in Bangalore, we will do a complete analysis of your website.",
    icon: ClipboardList,
    tone: "orange",
  },
  {
    title: "Analyzing and Observing",
    text: "Once the new website goes online, this is not the end of the redesigning process. You need to keep a keen eye on how the revamped site is working. Take note of the things that seem to be working and those that do not.",
    icon: Eye,
    tone: "blue",
  },
  {
    title: "Launching the Re-Designed Website",
    text: "When the redesigning has been done, you would want to let the people know about the changes and improvements that have been made to your website. Market your revamped website to reintroduce your business to your existing as well as target audience.",
    icon: Rocket,
    tone: "green",
  },
];

const WredProcessSection: React.FC = () => (
  <section className="wred-process-section" aria-labelledby="wred-process-title">
    <div className="wredesign-container">
      <motion.div
        className="wred-process-section__head"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.55 }}
      >
        <h2 id="wred-process-title">Our Redesigning Process</h2>
        <p>A proven step-by-step approach to transform your website with clarity and confidence.</p>
      </motion.div>

      <div className="wred-process-timeline">
        {steps.map((step, index) => (
          <motion.article
            key={step.title}
            className="wred-process-step"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <div className="wred-process-step__track" aria-hidden="true">
              <span className={`wred-process-step__dot wred-process-step__dot--${step.tone}`}>
                <step.icon size={22} strokeWidth={1.75} />
              </span>
              {index < steps.length - 1 && <span className="wred-process-step__line" />}
            </div>
            <div className="wred-process-step__card">
              <h3>
                {index + 1}. {step.title}
              </h3>
              <p>{step.text}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default WredProcessSection;
